import * as React from 'react'

import {
  Box,
  NumericMetric,
  Text,
  ValueChangeIndicator,
} from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  requested: number
  requestedLastMonth: number
}

const MetricRequestedPromotions = ({ requested, requestedLastMonth }: Props) => {
  const monthlyChange = Math.round((100 * (requested - requestedLastMonth)) / requestedLastMonth)
  const absMonthlyChange = Math.abs(monthlyChange) || 0

  const Footer = (
    <>
      <Box paddingTop="s2">
        <ValueChangeIndicator change={monthlyChange} target="neutral" />
      </Box>
      <Text weight="medium" size="100" color="grey800">
        {requested - requestedLastMonth === 0
          ? i18n.t('insights.widgets.approved_promotions.no_change')
          : i18n.t('insights.widgets.approved_promotions.change', {
              monthlyChange: absMonthlyChange,
            })}
      </Text>
    </>
  )

  return (
    <NumericMetric
      title={i18n.tp('insights.widgets.approved_promotions.requested_counted', {
        count: requested,
      })}
      value={requested}
      footer={requestedLastMonth !== 0 ? Footer : null}
    />
  )
}

export default MetricRequestedPromotions
